var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 2.9118C15.4121 3.17953 14.7791 3.36058 14.1152 3.44148C14.7932 3.02544 15.3135 2.36576 15.5586 1.57991C14.9238 1.96513 14.2222 2.24538 13.4728 2.39561C12.8755 1.7417 12.0218 1.33337 11.0771 1.33337C9.26548 1.33337 7.79574 2.84054 7.79574 4.69921C7.79574 4.96308 7.82391 5.21925 7.88026 5.46579C5.15208 5.32519 2.73381 3.98656 1.11381 1.9478C0.831132 2.44665 0.669601 3.02544 0.669601 3.64179C0.669601 4.809 1.24905 5.83945 2.12995 6.44328C1.59277 6.42691 1.08564 6.27379 0.642367 6.02339V6.06481C0.642367 7.6962 1.77402 9.05698 3.27663 9.36515C3.00147 9.44412 2.71128 9.48361 2.41169 9.48361C2.20039 9.48361 1.99378 9.46338 1.79374 9.4239C2.21166 10.7606 3.42314 11.7342 4.86001 11.7602C3.73681 12.6636 2.3206 13.2019 0.783237 13.2019C0.518401 13.2019 0.256383 13.1865 0 13.1557C1.45284 14.1091 3.17896 14.6667 5.03187 14.6667C11.0705 14.6667 14.3715 9.5385 14.3715 5.09021C14.3715 4.94382 14.3687 4.79744 14.3631 4.65395C15.0045 4.17917 15.5614 3.5869 16 2.9118Z",
    fill: "#151515"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.120e4704.svg";
export { ForwardRef as ReactComponent };